module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-right-9ec6f373538287fcf96aa052de16b746.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/chevron-right.svg
// module id = QwlY
// module chunks = 24